import {
  Field as HeadlessField,
  FieldProps as HeadlessFieldProps,
  Label as HeadlessLabel,
} from "@headlessui/react"
import { PropsWithChildren } from "react"

import { classNames } from "../../../../lib/classNames"
import { Label } from "../../informational/Label"
import { Checkbox } from "../Checkbox"
import { CheckboxLabel } from "./CheckboxLabel"
import { CheckboxLabelledRow } from "./CheckboxLabelledRow"

export interface CheckboxLabelledProps
  extends PropsWithChildren<
    Omit<HeadlessFieldProps, "className" | "onChange">
  > {
  className?: string
  labelClassName?: string
  checkboxClassName?: string
  disabled?: boolean
  checked: boolean
  onChange?: (checked: boolean) => void
  errorMessage?: string
}

export function CheckboxLabelled({
  children,
  className,
  labelClassName,
  checkboxClassName,
  checked,
  onChange,
  disabled,
  errorMessage,
  ...otherProps
}: CheckboxLabelledProps) {
  return (
    <>
      <HeadlessField
        as={CheckboxLabelledRow}
        className={classNames(
          onChange === undefined && "pointer-events-none",
          className
        )}
        disabled={disabled}
        {...otherProps}
      >
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          className={checkboxClassName}
        />
        <HeadlessLabel
          as={CheckboxLabel}
          className={classNames(
            "data-disabled:cursor-not-allowed data-disabled:color-disabled color-default text-body",
            labelClassName
          )}
        >
          {children}
        </HeadlessLabel>
      </HeadlessField>
      {errorMessage && <Label errorMessage={errorMessage} />}
    </>
  )
}
